import React from 'react';

const CarouselControls = ({ 
  onNext, 
  onPrev, 
  currentIndex, 
  totalPlans,
  setCurrentIndex, 
  isAtStart, 
  isAtEnd,
  maxIndex,
  cardsToShow
}) => {
  return (
    <>
      <button 
        className={`carousel-btn prev ${isAtStart ? 'at-start' : ''}`}
        onClick={onPrev} 
        disabled={isAtStart}
        aria-label="Previous plan"
      >
        <span>‹</span>
        <div className="btn-ripple"></div>
      </button>

      <button 
        className={`carousel-btn next ${isAtEnd ? 'at-end' : ''}`}
        onClick={onNext} 
        disabled={isAtEnd}
        aria-label="Next plan"
      >
        <span>›</span>
        <div className="btn-ripple"></div>
      </button>

      {totalPlans > 1 && (
        <div className="carousel-indicators">
          {Array.from({ length: totalPlans }).map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => {
                const targetIndex = Math.min(index, maxIndex);
                setCurrentIndex(targetIndex);
              }}
              aria-label={`Go to plan ${index + 1}`}
            >
              <div className="indicator-fill"></div>
            </button>
          ))}
        </div>
      )}
    </>
  );
};

export default CarouselControls;